"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.galleryTagsTool = void 0;
const zod_1 = require("zod");
exports.galleryTagsTool = {
    name: 'galleryTags',
    description: `MANDATORY: Always check if the user's message contains content related to any tags in the tool data and call this tool if matches are found.

    This tool informs the chat component about tags used in conversations.
    Tags are passed in conversation <tool-data toolName="galleryTags"><tool-data-entry key="tags">TAG_DETECTION_CONDITIONS</tool-data-entry></tool-data> xml tags input.
    Consider <tool-data-entry key="usedTags"> as already noted and do not return those tags again.
    
    WHEN TO CALL THIS TOOL:
    - Check the tool data for available tags
    - Call this tool with the relevant tags
    
    Only <tool-data-entry key="tags"> should be used to return new tags. If no new tags are found, do not execute the tool at all.
    This tool handles its own response continuation - you will continue responding normally after it executes.
    `,
    zodSchema: zod_1.z.object({
        foundTags: zod_1.z.array(zod_1.z.string().describe('The conversation input based on which relevant tags should be communicated.')).describe('Array of gallery tag names that match the user message.')
    }),
    blockStream: false
};
